import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { func, string } from 'prop-types';
import React from 'react';

const PointCard = ({ content, renderCardContent, title }) => {
  const { isTabletLG, isTabletSM } = useScreenSize();
  return (
    <Flex
      bg={theme.colors.white[10]}
      flexDirection={renderCardContent && isTabletSM ? 'row' : 'column'}
      height={isTabletSM ? 95 : 160}
      justifyContent="space-between"
      {...(renderCardContent && isTabletSM && { alignItems: 'center' })}
      py={isTabletSM ? 16 : 24}
      {...(!isTabletLG && { maxWidth: 300 })}
      mr="3px"
      px={24}
      width={isTabletLG ? '100%' : '33%'}
    >
      <Typography
        color={theme.colors.white[100]}
        variant={isTabletSM ? 'MS-regular-s18-lh22' : 'MS-regular-s24-lh28'}
      >
        {title}
      </Typography>
      {renderCardContent || (
        <Typography
          color={theme.colors.schoolBusYellow[60]}
          variant={isTabletSM ? 'BN-bold-s28-lh25' : 'BN-bold-s43-lh38'}
        >
          {content}
        </Typography>
      )}
    </Flex>
  );
};

PointCard.defaultProps = {
  content: null,
  renderCardContent: null,
};

PointCard.propTypes = {
  content: string,
  renderCardContent: func,
  title: string.isRequired,
};

export default PointCard;
